import { Component, Input } from '@angular/core';

@Component({
    selector: 'photo-with-credit',
    templateUrl: './photo-with-credit.html',
    styleUrls: ['./photo-with-credit.scss'],
})
export class PhotoWithCredit {
    constructor() {}

    @Input() imageSrc: string;
    @Input() photoCredits: string;
    @Input() bannerText: string;


}


// WEBPACK FOOTER //
// ./src/app/partials/photo-with-credit/photo-with-credit.component.ts